@charset "UTF-8";

/* src/app/forms/formview/editform.component.scss */
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.view-container {
  display: inline;
  flex-direction: column;
}
.view-container > * {
  width: 100%;
}
.radio-selection {
  padding: 4px 8px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 80%;
  font-weight: bold;
}
.switch-label {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  font-weight: bold;
  cursor: pointer;
}
.menu-label {
  margin-left: var(--tem-space-2);
}
.form-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .form-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.multi-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .multi-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.wizard-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.wizard-steps {
  padding: var(--tem-space-2) var(--tem-space-3);
}
.view-container {
  width: 100%;
}
.mat-mdc-form-field {
  width: 100%;
  height: 100%;
}
:host > .mat-figure {
  justify-content: flex-start !important;
  left: 20px !important;
  display: inline !important;
}
.config {
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
  align-items: center;
}
.fitcontent {
  display: flex;
  width: 100%;
}
gridster-item {
  padding-top: 5px;
  border-radius: var(--tem-radius);
}
gridster {
  border-radius: var(--tem-radius);
}
gridster-item ::ng-deep .tem-field-label {
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}
gridster-item ::ng-deep .tem-field-suffix .ant-btn {
  height: 22px;
  width: 22px;
  min-width: 22px;
  padding: 0;
}
.mat-form-field-infix {
  height: 100%;
}
.editform {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
nz-tabs {
  height: 100%;
}
:host ::ng-deep .editform .ant-tabs-content,
:host ::ng-deep .editform .ant-tabs-tabpane {
  height: 100%;
}
.full {
  position: relative;
  height: 100%;
}
.flex-spacer {
  flex-grow: 1;
}
.space {
  padding: 4px;
}
gridster.mobile {
  height: auto !important;
}
gridster.mobile gridster-item {
  height: auto !important;
}
.mat-horizontal-content-container {
  padding: 0 2px 2px 2px !important;
}
.form-configuration-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.step-wizard-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.step-wizard-btn {
  width: 100%;
  flex-direction: row;
  justify-content: center;
  display: flex;
}
.title-multi {
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.title-multi button {
  padding: 0 15px;
  font-size: 0.8em;
  line-height: 24px !important;
}
.data-information {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  margin-bottom: 4px;
}
.data-information-title {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}
.data-information h2 {
  color: red;
  font-size: 100%;
  text-align: center;
  margin-bottom: 0;
  line-height: 18px;
}
.multi-table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.container {
  height: 100%;
}
.suspended-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  border: 1px solid var(--tem-border);
  overflow: auto;
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
  right: 0;
  top: 50px;
  z-index: 100;
  background: var(--tem-surface);
}
.suspended-menu-actions {
  width: 100%;
  background-color: var(--tem-deep);
  align-items: center;
  color: #fff;
  height: 30px;
  justify-items: center;
  cursor: move;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 200px;
  font-size: 10px;
  padding: 10px;
}
.suspended-menu-list {
  min-height: 60px;
  background: var(--tem-surface);
  overflow: hidden;
  display: block;
}
.suspended-menu-actions-in {
  cursor: pointer;
  z-index: 100;
  line-height: 10px;
}
.suspended-menu-box {
  padding: 5px 10px;
  border-bottom: solid 1px var(--tem-border);
  color: var(--tem-ink);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: var(--tem-surface);
  font-size: 10px;
}
.cdk-drag-preview {
  box-sizing: border-box;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.suspended-menu-box:last-child {
  border: none;
}
.suspended-menu-list.cdk-drop-list-dragging .suspended-menu-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.expanded {
  top: 20px;
  right: 20px;
  padding: 10px;
  position: fixed;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  overflow: auto;
  z-index: 100;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background-color: var(--tem-bg);
}
.small {
  left: 70px;
}
.big {
  left: 260px;
}
.normal {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
nz-divider[nztype=vertical] {
  height: 24px;
}
.float-button {
  position: absolute;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  left: 45%;
  top: 3px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  box-shadow: var(--tem-shadow);
}
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*# sourceMappingURL=editform.component.css.map */
